export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-100 border border-background-200/70 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-primary-500 flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20illustration%20of%20a%20mobile%20app%20interface%20with%20social%20media%20content%20feed%2C%20warm%20orange%20coral%20and%20peach%20gradients%2C%20clean%20flat%20design%20aesthetic%2C%20minimal%20geometric%20elements%2C%20editorial%20quality%2C%20no%20text%20no%20people&width=560&height=560&seq=app-qr-mock&orientation=squarish"
                alt="51今日吃瓜手机APP"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
              📱 手机吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
              下载51今日吃瓜APP，随时随地追最新吃瓜动态。支持iOS与Android双平台，推送提醒让你第一时间吃到最新鲜的瓜。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
              >
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-secondary-600 transition-colors"
              >
                <i className="ri-android-line text-lg"></i>
                安卓版下载
              </a>
            </div>
            <p className="text-xs text-foreground-400 mt-4">
              支持iOS 14+ / Android 8.0+ | 已通过安全检测
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}